import API from '@/services/endpoint'
import { SET_EVENT_COUNTER } from "../../mutation-types";

/**
 * API Get Request to fetch the counter event
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object} A object of counter event
 */
export async function fetchCounterEvent({commit, state}) {
  const { url } = state;
  let responseObj = await API.get(url);
  let { data: { message: { event } } } = responseObj;
  commit(SET_EVENT_COUNTER, event)
}
